import Image from "next/image";
import Link from "next/link";
import React from "react";
import { CarModel } from "./CarsInfo";
import CustomLink from "../CustomLink";

const CarModelCardMobile: React.FC<CarModel> = ({
  imageSrc,
  logoSrc,
  altText,
  carLink,
}) => {
  const isStackedLogo = altText === "Yaris Cross";
  return (
    <div className="flex mx-auto justify-center px-4 max-w-80 items-center w-full transition-all max-lg:ml-20 duration-300 ease-in-out rounded-xl">
      <div
        className="flex relative h-80 overflow-y-hidden rounded-xl flex-col  w-full origin-left"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgb(0, 0, 0, 0.8), transparent, rgb(0, 0, 0, 0.8)), url('${imageSrc}')`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
      >
        <div className="w-full py-4 relative flex flex-col items-center transition-all duration-500 justify-between h-full">
          <img
            width={isStackedLogo ? 1944 : 400}
            height={isStackedLogo ? 809 : 400}
            loading="lazy"
            src={logoSrc}
            alt={`${altText} logo`}
            className={
              isStackedLogo
                ? "mx-auto h-auto w-[78%] object-contain"
                : "mx-auto w-10/12 aspect-[6.25]"
            }
          />
          <CustomLink
            href={carLink}
            prefetch={false}
            className="border text-sm relative text-center bg-white w-10/12 text-black px-5 py-2 rounded"
          >
            SAIBA MAIS
          </CustomLink>
        </div>
      </div>
    </div>
  );
};

export default CarModelCardMobile;
